export default function AdminLayoutGlobalLoading() {
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
      <div className="flex items-center justify-center w-28 h-28 rounded-2xl bg-white shadow-lg animate-pulse">
        <img
          src="/images/LogoIcon.svg"
          alt=""
          className="w-18 h-18"
        />
      </div>
    </div>
  );
};